import axios from "axios";
import { hostname } from "src/HostName";

const addAgentFareInstance = axios.create({
  baseURL: hostname,
  headers: {
    "Content-Type": "application/json",
  },
});
export const getb2bAgnetListApi = () =>
  addAgentFareInstance.post(`get/b2bAgents`, {});
export const updateb2bAgnetApi = (data) =>
  addAgentFareInstance.patch(`update/b2bAgents`, data);
export const deleteb2bAgnetApi = (id) =>
  addAgentFareInstance.delete(`delete/b2bAgents/${id}`);
export const createAgentApi = (data) =>
  addAgentFareInstance.post(`create/agents`, data);

export const addSupplierApi = (data) =>
  addAgentFareInstance.post(`add/supplier`, data);
export const deleteSupplierApi = (userId, gdsType) =>
  addAgentFareInstance.delete(
    `delete/supplier?userid=${userId}&gdsType=${gdsType}`
  );

export const duplicateFlightRuleApi = (data) =>
  addAgentFareInstance.post(`add/duplicate/rule`, data);
export const replicaSupplierApi = (data) => {
  return addAgentFareInstance.post(`replica/supplier`, data);
};
export const replicaSupplierRuleApi = (data) => {
  return addAgentFareInstance.post(`replicate/supplier/rule`, data);
};
